export const getRowStyle = (params) => {
  if (params.node.rowIndex % 2 === 0) {
    return { background: '#ECECF0' };
  }
};
